module.exports = __webpack_public_path__ + "img/product.6581b870.png";